export default __webpack_public_path__ + "static/media/4.7091e838.jpg";